/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Catch Backend
 * Catch Backend API
 * OpenAPI spec version: 0.1.0
 */

/**
 * API-facing biomarker classification after applying Sanity optimal rules and Junction interpretation.

Note: Internal classification logic uses InternalBiomarkerClassification which includes
directional variants (HIGH/LOW) for content selection, but these are mapped to generic
OUT_OF_RANGE before being exposed in the API.
 */
export type BiomarkerClassification = typeof BiomarkerClassification[keyof typeof BiomarkerClassification];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const BiomarkerClassification = {
  pending: 'pending',
  no_results: 'no_results',
  optimal: 'optimal',
  normal: 'normal',
  out_of_range: 'out_of_range',
  critical: 'critical',
} as const;
